import { configureStore } from "@reduxjs/toolkit";
import logindata from "./login_data";
import themedata from "./theme_data";
import mainpagedata from "./mainpage_data";
import pageselectdata from "./pageselect_data";
import configdata from "./cofig_data";
import alarmdata from "./alarm_data";
import gatewayconfigdata from "./gateway_config_data" ;
import deviceconfigdata from "./device_config_data" ;
import reportdata  from "./report_data";
import diagnosticdata  from "./diagnostic_data";

export default configureStore({
    reducer: {
        logindata: logindata,
        themedata: themedata,
        mainpagedata: mainpagedata,
        pageselectdata: pageselectdata,
        configdata: configdata,
        alarmdata: alarmdata,
        gatewayconfigdata: gatewayconfigdata,
        deviceconfigdata: deviceconfigdata,
        reportdata: reportdata,
        diagnosticdata: diagnosticdata
    }
})